import { SURFACE_COLORS, SURFACE_LABELS } from '../config/constants';

/**
 * Calcule la distance totale d'une route en kilomètres
 */
export const calculateDistance = (routeCoordinates) => {
    const R = 6371; // Rayon de la Terre en km
    let distance = 0;

    for (let i = 0; i < routeCoordinates.length - 1; i++) {
        const p1 = routeCoordinates[i];
        const p2 = routeCoordinates[i + 1];
        const dLat = (p2[0] - p1[0]) * Math.PI / 180;
        const dLon = (p2[1] - p1[1]) * Math.PI / 180;
        const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(p1[0] * Math.PI / 180) *
            Math.cos(p2[0] * Math.PI / 180) *
            Math.sin(dLon / 2) ** 2;
        distance += R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    return distance;
};

/**
 * Retourne le label français d'une surface
 */
export const getSurfaceLabel = (surface) => {
    return SURFACE_LABELS[surface] || surface;
};

/**
 * Retourne la couleur d'une surface
 */
export const getSurfaceColor = (surface) => {
    return SURFACE_COLORS[surface] || '#999999';
};

/**
 * Recherche un lieu via l'API Nominatim
 */
export const searchLocation = async (query) => {
    if (query.length < 3) return [];

    try {
        const response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5`
        );
        return await response.json();
    } catch (err) {
        console.error('Erreur recherche:', err);
        return [];
    }
};